import { List, Map } from 'immutable';

import { shapeAiOperationsForAPI } from '../profiles/v2/ai';
import { tagsToList } from '../tags';
import { keepOld } from '../iterable/keepOld';

import { MAX_NUMBER_OF_TAGS } from '../../constants/validations';
import { OPERATIONS } from '../../constants/bulkEdit';
import { OPERATION } from '../../constants/ai';
import { VALUE } from '../../constants/product';
import { EMPTY } from '../../constants';
import { FORM } from '../../constants/forms';
import ATTRIBUTE from '../../constants/attributes';

export function getAiOperations({ channel, products, profile }) {
  function reduceOperations(operations, item) {
    const {
      destination_field: destination,
      input: {
        instructions,
      },
      operation,
    } = item;

    if (!profile.getIn(['sections', destination])) return operations;

    return operations.push(
      Map({
        products,
        type: OPERATIONS[channel].AI,
        value: Map({
          channel,
          destination_field: destination,
          input: Map({
            instructions,
          }),
          operation,
        }),
      })
    );
  }

  return shapeAiOperationsForAPI({ state: profile.get('ai') }).reduce(reduceOperations, EMPTY.LIST);
}

export function getProductOperation({ ai, attribute, channel, productId }) {
  function getOperationType() {
    switch (attribute) {
      case ATTRIBUTE.DESCRIPTION: {
        return OPERATIONS[channel].DESCRIPTION.SET;
      }

      case ATTRIBUTE.TAGS: {
        return OPERATIONS[channel].TAGS.CHANGE_TO;
      }

      case ATTRIBUTE.TITLE: {
        return OPERATIONS[channel].TITLE.SET;
      }

      default: {
        return undefined;
      }
    }
  }

  function getOperationValue() {
    switch (attribute) {
      case ATTRIBUTE.TAGS: {
        return tagsToList({ channel, tags: ai.get('generated') });
      }

      default: {
        return ai.get('generated');
      }
    }
  }

  const products = List([productId]);
  const type = getOperationType();
  const value = getOperationValue();

  return Map({ ai: Map({ original: ai.get('original') }), products, type, value });
}

export function getProductValue({ attribute, channel, operation, product, response }) {
  switch (attribute) {
    case ATTRIBUTE.TAGS: {
      switch (operation) {
        case OPERATION.ADD_MAXIMUM: {
          return product.getIn([FORM.TAGS, VALUE])
            .mergeWith(keepOld, response)
            .slice(0, MAX_NUMBER_OF_TAGS[channel]);
        }

        default: {
          return response;
        }
      }
    }

    default: {
      return response;
    }
  }
}
